import React from "react";
import { twMerge } from "tailwind-merge";
import { theme } from "./index";

interface SettingsProps {
  className?: string;
}

export const Settings: React.FC<SettingsProps> = ({ className }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(
      theme,
      className,
    )}
  >
    <path d="M15.9257 10.4085C15.9643 10.1186 15.9837 9.81896 15.9837 9.50002C15.9837 9.19075 15.9643 8.88147 15.916 8.59153L17.878 7.06449C18.0519 6.92918 18.1003 6.66823 17.9939 6.47493L16.1383 3.26622C16.0223 3.05359 15.7807 2.98594 15.5681 3.05359L13.2582 3.98141C12.7749 3.61415 12.2627 3.30488 11.6925 3.07292L11.3446 0.618059C11.3059 0.386103 11.1126 0.221802 10.8806 0.221802H7.16936C6.9374 0.221802 6.75377 0.386103 6.71511 0.618059L6.36718 3.07292C5.79695 3.30488 5.27505 3.62381 4.80148 3.98141L2.49159 3.05359C2.27896 2.97627 2.03734 3.05359 1.92136 3.26622L0.0753858 6.47493C-0.0405919 6.67789 -0.00193274 6.92918 0.191363 7.06449L2.15332 8.59153C2.105 8.88147 2.06634 9.20041 2.06634 9.50002C2.06634 9.79963 2.08567 10.1186 2.13399 10.4085L0.172034 11.9356C-0.00193272 12.0709 -0.0502567 12.3318 0.0560562 12.5251L1.9117 15.7338C2.02768 15.9464 2.2693 16.0141 2.48192 15.9464L4.79181 15.0186C5.27505 15.3859 5.78729 15.6952 6.35751 15.9271L6.70545 18.382C6.75377 18.6139 6.9374 18.7782 7.16936 18.7782H10.8806C11.1126 18.7782 11.3059 18.6139 11.3349 18.382L11.6828 15.9271C12.253 15.6952 12.7749 15.3859 13.2485 15.0186L15.5584 15.9464C15.771 16.0238 16.0127 15.9464 16.1286 15.7338L17.9843 12.5251C18.1003 12.3125 18.0519 12.0709 17.8683 11.9356L15.9257 10.4085ZM9.025 12.9794C7.11137 12.9794 5.54567 11.4137 5.54567 9.50002C5.54567 7.58639 7.11137 6.02069 9.025 6.02069C10.9386 6.02069 12.5043 7.58639 12.5043 9.50002C12.5043 11.4137 10.9386 12.9794 9.025 12.9794Z" />
  </svg>
);
